var exports = {
  "h_": "description__BXX4wV",
  "Dj": "infoList__rWEJho",
  "KN": "infoListItem__lp8Omt",
  "mV": "draftIssuesLabel__mIXli-",
  "G": "infoIcon__mjscAH",
  "NR": "infoIconSuccess__2sQaxP",
  "PI": "infoIconMuted__gprPVr",
  "ZZ": "field__iuHiPx",
};

module.exports = exports;
